import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { catchError, finalize, map, mergeMap, of } from 'rxjs';
import { DataService } from 'src/app/shared/services/data.service';
import { hideSpinner, navigationStart } from '../common/navigation/navigation.actions';
import { showSuccessMessage } from '../common/toast-message/toast.message.actions';
import { contactUs, contactUsFailure, contactUsSuccess, existingSuggestRoute, existingSuggestRouteFailure, existingSuggestRouteSuccess, suggestRoute, suggestRouteFailure, suggestRouteSuccess } from './general-data.actions';
import { OkResponseModel } from 'src/app/model/response/ok.resopnse.model';

@Injectable()
export class GeneralDataEffects {
    constructor(
        private actions$: Actions,
        private dataService: DataService,
        private router: Router,
    ) { }

    suggestRoute$ = createEffect(() =>
        this.actions$.pipe(
            ofType(suggestRoute),
            mergeMap((action) =>
                this.dataService.getByPost<OkResponseModel>('generaldata/suggestRoute', action.request).pipe(
                    map((response) => suggestRouteSuccess({ response: response.message })),
                    catchError((error) => of(suggestRouteFailure({ error }))),
                    finalize(() => { })
                )
            )
        )
    );

    suggestRouteSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(suggestRouteSuccess),
            mergeMap(({ response }) => {
                return of(showSuccessMessage({ response: response }), hideSpinner({}))
            })
        ))



    existingSuggestRoute$ = createEffect(() =>
        this.actions$.pipe(
            ofType(existingSuggestRoute),
            mergeMap((action) =>
                this.dataService.getByPost<OkResponseModel>('generaldata/existingSuggestRoute', action.request).pipe(
                    map((response) => existingSuggestRouteSuccess({ response: response.message })),
                    catchError((error) => of(existingSuggestRouteFailure({ error }))),
                    finalize(() => { })
                )
            )
        )
    );

    existingSuggestRouteSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(existingSuggestRouteSuccess),
            mergeMap(({ response }) => {
                return of(showSuccessMessage({ response: response }), hideSpinner({}))
            })
        ))


    contactUs$ = createEffect(() =>
        this.actions$.pipe(
            ofType(contactUs),
            mergeMap((action) =>
                this.dataService.getByPost<OkResponseModel>('generaldata/contactUs', action.request).pipe(
                    map((response) => contactUsSuccess({ response: response.message })),
                    catchError((error) => of(contactUsFailure({ error }))),
                    finalize(() => { })
                )
            )
        )
    );

    contactUsSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(contactUsSuccess),
            mergeMap(({ response }) => {
                return of(hideSpinner({}),
                    showSuccessMessage({ response: response }),
                    navigationStart(this.router.navigate(['/'])
                    ))
            })
        ))
}
